<template>
  <div class="relative">
    <el-input
      placeholder="请输入地点、街道等位置信息"
      v-model="issue.inputValue"
      ref="reference"
      @focus="visible = true"
      @blur="onBlur"
    ></el-input>
    <el-select-dropdown ref="popper" append-to-body v-show="visible">
      <ul>
        <li v-for="item in poiList" :key="item.id" class="py-2 px-3 cursor-pointer hover:bg-theme-gray">
          <div @click="onSelect(item)">
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
    </el-select-dropdown>

    <!--    <el-select v-model="value" filterable remote :remote-method="onRemoteMethod" @change="onChangeValue">-->
    <!--      <el-option v-for="item in poiList" :key="item.id" :label="item.name" :value="item.id"/>-->
    <!--    </el-select>-->
  </div>
</template>

<script>
import ElSelectDropdown from 'dygc-ui/packages/select/src/select-dropdown'

export default {
  name: 'TextMap',
  props: {
    issue: {
      type: Object,
      default: () => ({})
    }
  },
  components: { ElSelectDropdown },
  data() {
    return {
      value: '',
      poiList: [],
      visible: false
    }
  },
  methods: {
    onChangeValue() {
      let item = this.poiList.find(i => i.id === this.value)
      if (item) {
        this.issue.changeValue(item)
        this.$emit('change', item)
      }
    },
    onRemoteMethod(val) {
      this.issue.getPoiList(val).then(list => {
        this.poiList = list
      })
    },
    onBlur() {
      setTimeout(() => {
        console.log('blur')
        // this.visible=false
      }, 20)
    },
    onSelect(item) {
      this.issue.inputValue = item.name
      this.visible = false
      this.$emit('change', item)
      this.issue.changeValue(item)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.value = this.issue.inputValue
    })
  },
  watch: {
    'issue.inputValue'(val) {
      this.onRemoteMethod(val)
    }
  }
}
</script>
